import { ExportListResponse } from '@core/interface/export-list.interface';
import { ExportPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/export-purchase-dispute.request.dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { AssignPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/assign-purchase-dispute.request.dto';
import { CreatePurchaseDisputeMessageRequestDto } from '@domain/purchase-dispute/dtos/create-purchase-dispute-message.request.dto';
import { ListPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/list-purchase-dispute.request.dto';
import { PurchaseDisputeResponseDto } from '@domain/purchase-dispute/dtos/purchase-dispute.response.dto';
import { SummaryPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/summary-purchase-dispute.request.dto';
import { SummaryPurchaseDisputeResponseDto } from '@domain/purchase-dispute/dtos/summary-purchase-dispute.response.dto';
import { UpdatePriorityPurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/update-priority-purchase-dispute.request.dto';
import { UpdateStatePurchaseDisputeRequestDto } from '@domain/purchase-dispute/dtos/update-state-purchase-dispute.request.dto';

@Injectable({ providedIn: 'root' })
export class PurchaseDisputeService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('purchase/dispute');
  }

  list(request: ListPurchaseDisputeRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<PurchaseDisputeResponseDto>>
    >(queryUrl, { params: this.toParams(request) });
  }

  show(refId: string) {
    return this.http.get<ApiResponse<PurchaseDisputeResponseDto>>(
      `${this.getApiUrl()}/show/${refId}`,
    );
  }

  summary(request: SummaryPurchaseDisputeRequestDto) {
    return this.http.get<ApiResponse<SummaryPurchaseDisputeResponseDto>>(
      `${this.getApiUrl()}/summary`,
      { params: this.toParams(request) },
    );
  }

  updateState(request: UpdateStatePurchaseDisputeRequestDto) {
    const { refId, ...body } = request;
    return this.http.patch<ApiResponse<PurchaseDisputeResponseDto>>(
      `${this.getApiUrl()}/${refId}/state`,
      body,
    );
  }

  updatePriority(request: UpdatePriorityPurchaseDisputeRequestDto) {
    const { refId, ...body } = request;
    return this.http.patch<ApiResponse<PurchaseDisputeResponseDto>>(
      `${this.getApiUrl()}/${refId}/priority`,
      body,
    );
  }

  assign(request: AssignPurchaseDisputeRequestDto) {
    const { refId, ...body } = request;
    return this.http.patch<ApiResponse<PurchaseDisputeResponseDto>>(
      `${this.getApiUrl()}/${refId}/assign`,
      body,
    );
  }

  createMessage(request: CreatePurchaseDisputeMessageRequestDto) {
    const { refId, ...body } = request;
    return this.http.post<ApiResponse<PurchaseDisputeResponseDto>>(
      `${this.getApiUrl()}/${refId}/message`,
      body,
    );
  }

  private toParams<T extends object>(request: T): Record<string, string> {
    const params: Record<string, string> = {};
    for (const [key, value] of Object.entries(request)) {
      if (value === undefined || value === null || value === '') continue;
      params[key] = String(value);
    }
    return params;
  }

  export(request: ExportPurchaseDisputeRequestDto) {
    const queryUrl = `${this.getApiUrl()}/export`;
    return this.http.post<ApiResponse<ExportListResponse>>(queryUrl, request);
  }
}
